import { useStore } from '../store/storeHooks';

export function useKernel() {
  const store = useStore();
  return store.kernel;
}